import { render, staticRenderFns } from "./dailyCheckIn.vue?vue&type=template&id=6f04e54c&scoped=true"
import script from "./dailyCheckIn.vue?vue&type=script&lang=js"
export * from "./dailyCheckIn.vue?vue&type=script&lang=js"
import style0 from "./dailyCheckIn.vue?vue&type=style&index=0&id=6f04e54c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04e54c",
  null
  
)

export default component.exports